@if (visible) {
  <div class="confirmation-modal" [ngClass]="[tipo, animateOut ? 'fade-out' : '']"
    (click)="onBackdropClick($event)">
    <div class="modal-content">
      @if (imagen) {
        <img [src]="imagen" alt="icon" />
      }
      <p class="message">{{ mensaje }}</p>
      <div class="actions">
        <button (click)="onCancel()" class="btn btn-cancel">Cancelar</button>
        <button (click)="onConfirm()" class="btn btn-confirm">Aceptar</button>
      </div>
    </div>
  </div>
}